import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import JSONPretty from 'react-json-pretty';
import { getRecentReqData } from '../../../services/apisService';

type DataTypes = {
  request: string;
  response: string;
  responseTime: number;
  responseCode: number;
  receivedAt: string;
  errorCode: string | null;
  status: string;
};
function RecentReq() {
  const { id } = useParams<{ id: string }>();
  const [isCopiedTxt, setIsCopiedTxt] = useState<boolean>(false);

  const [data, setData] = useState<DataTypes[] | []>([]);

  const copyText = (val: string) => {
    const divId: HTMLElement | null = document.getElementById(val);
    if (divId) {
      const txt = divId.textContent;
      if (txt) {
        navigator.clipboard.writeText(txt);
        setIsCopiedTxt(true);
        setTimeout(() => {
          setIsCopiedTxt(false);
        }, 1500);
      }
    }
  };

  const callRecentReqApi = async () => {
    const res: any = await getRecentReqData(id || '');
    if (res && res.success) {
      setData(res.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    callRecentReqApi();
  }, []);

  const calculateTime = (receivedAt: string) => {
    const oldDate = moment(receivedAt);
    const result = oldDate.fromNow();
    return result;
  };

  const parseMethodName = (request: string) => {
    try {
      const parseObj = JSON.parse(request);
      return parseObj.method || '';
    } catch (err) {
      return '';
    }
  };

  return (
    <div className="mt-5 mb-5">
      <h5>Recent Request</h5>
      {isCopiedTxt && (
        <div className="alert alert-success text-center mt-3 mb-3" role="alert">
          Copied
        </div>
      )}
      <div className="row justify-content-between mt-4">
        <div className="card p-3 h-100">
          <div style={{ padding: '1rem 1.25rem', marginRight: '1.25rem' }}>
            <table className="w-100">
              <thead>
                <tr>
                  <th className="col-1">#</th>
                  <th className="col-3">METHOD</th>
                  <th className="col-2">ERROR CODE</th>
                  <th className="col-2">HTTP</th>
                  <th className="col-2">RESPONSE TIME</th>
                  <th className="col-2">SENT</th>
                </tr>
              </thead>
            </table>
          </div>
          <div className="accordion accordion-sec" id="accordionExample">
            {data && data.length > 0 ? (
              data.map((item: DataTypes, index: number) => (
                <div className="accordion-item" key={`req-${index.toString()}`}>
                  <h2 className="accordion-header" id={`heading-${index}`}>
                    <div
                      className="accordion-button collapsed"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded="true"
                      aria-controls={`collapse${index}`}
                    >
                      <table className="w-100">
                        <tbody>
                          <tr className="accordion-heading">
                            <td className="col-1">{index + 1}</td>
                            <td className="col-3">{parseMethodName(item.request)}</td>
                            <td className="col-2">{item.errorCode}</td>
                            <td className="col-2">{item.responseCode ? item.responseCode : '-'}</td>
                            <td className="col-2">{item.responseTime ? `${item.responseTime} ms` : '-'}</td>
                            <td className="col-2">
                              {item.receivedAt ? calculateTime(item.receivedAt) : '-'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`heading-${index}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <table className="w-100">
                        <tbody>
                          <tr className="row">
                            <td className="col-6 border p-3" style={{ verticalAlign: 'top' }}>
                              <p className="d-flex text-align-end justify-content-end">
                                <i
                                  className="fa-regular fa-copy text-primary fs-6 cursor"
                                  aria-hidden
                                  onClick={() => copyText(`request-${index}`)}
                                />
                              </p>
                              <JSONPretty
                                id={`request-${index}`}
                                data={item.request}
                                errorStyle="white-space: pre-wrap"
                                mainStyle="white-space: pre-wrap"
                              />
                            </td>
                            <td className="col-6 border p-3" style={{ verticalAlign: 'top' }}>
                              <p className="d-flex text-align-end justify-content-end">
                                <i
                                  className="fa-regular fa-copy text-primary fs-6 cursor"
                                  aria-hidden
                                  onClick={() => copyText(`response-${index}`)}
                                />
                              </p>
                              <JSONPretty
                                id={`response-${index}`}
                                data={item.response}
                                errorStyle="white-space: pre-wrap"
                                mainStyle="white-space: pre-wrap"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center">
                <hr />
                <p className="mt-4 fs-6 text-muted">
                  No Data
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentReq;
